import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import apiService from '../services/apiService';
import { BlobScene } from '../components/blob/BlobScene';
import { DEFAULT_COLORS } from '../components/blob/blobConfig';
import { resolveArtefactBlobConfig } from '../components/blob/resolveArtefactBlobConfig';
import './BlobSnapshotPage.css';

function getSnapshotArtefactFields(snapshot) {
  return [
    snapshot?.artefact,
    snapshot?.artifact,
    snapshot?.artefact_name,
    snapshot?.artifact_name,
    snapshot?.persona,
    snapshot?.persona_name,
    snapshot?.name,
    snapshot?.title,
    snapshot?.type,
    snapshot?.config?.artefact,
    snapshot?.config?.artifact,
    snapshot?.config?.type,
  ];
}

function getBaseBlobConfigForSnapshot(snapshot) {
  const haystack = getSnapshotArtefactFields(snapshot)
    .filter((value) => typeof value === 'string')
    .map((value) => value.toLowerCase().trim())
    .filter(Boolean)
    .join(' ');
  return resolveArtefactBlobConfig(haystack);
}

function BlobSnapshotPage() {
  const { code } = useParams();
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchSnapshot() {
      try {
        const result = await apiService.getBlobSnapshot(code);
        if (result.success && result.snapshot) {
          setSnapshot(result.snapshot);
        } else {
          setError(result.error || 'Snapshot not found');
        }
      } catch (e) {
        setError('Failed to load snapshot');
      } finally {
        setLoading(false);
      }
    }
    fetchSnapshot();
  }, [code]);

  if (loading) {
    return <div className="blob-snapshot-loading">Loading...</div>;
  }

  if (error || !snapshot) {
    return <div className="blob-snapshot-error">{error || 'Not found'}</div>;
  }

  const baseConfig = getBaseBlobConfigForSnapshot(snapshot);
  const mergedConfig = { ...baseConfig, ...(snapshot.config || {}) };
  const color1 = mergedConfig.gradientColor1 || DEFAULT_COLORS.gradientColor1;
  const color2 = mergedConfig.gradientColor2 || DEFAULT_COLORS.gradientColor2;
  const color3 = mergedConfig.gradientColor3 || DEFAULT_COLORS.gradientColor3;

  return (
    <div className="blob-snapshot-page">
      <BlobScene
        gradientColor1={color1}
        gradientColor2={color2}
        gradientColor3={color3}
        baseConfig={baseConfig}
        configOverride={snapshot.config || {}}
      />
    </div>
  );
}

export default BlobSnapshotPage;
